var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.coLoader
    ? _c("v-select", {
        staticClass: "search-condition",
        attrs: {
          "hide-details": "",
          solo: "",
          items: _vm.coItems,
          color: "primary",
          multiple: _vm.multiple,
          label: _vm.label,
          "menu-props": _vm.maxHeight
        },
        on: { change: _vm.handleChange },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function(data) {
              return [
                _vm.hasProps
                  ? [
                      _vm._t("selection", null, {
                        item: data.item,
                        index: data.index,
                        selected: data.selected,
                        disabled: data.disabled
                      })
                    ]
                  : [
                      _vm.getVisibility(data.index)
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "chip--select-multi",
                              attrs: {
                                color: "secondary",
                                "text-color": "whitePure"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: { width: "fit-content" },
                                  attrs: { title: data.item.text }
                                },
                                [_vm._v(" " + _vm._s(data.item.text) + "...")]
                              ),
                              _vm._v(" "),
                              _vm.extendItemCount > 0
                                ? _c("small", {
                                    staticStyle: { "margin-left": "5px" },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$tc(
                                          "LBL_OTHER_ITEMS",
                                          _vm.extendItemCount,
                                          { number: _vm.extendItemCount }
                                        )
                                      )
                                    }
                                  })
                                : _vm._e()
                            ]
                          )
                        : !_vm.multiple
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "chip--select-multi",
                              attrs: {
                                color: "secondary",
                                "text-color": "whitePure"
                              }
                            },
                            [
                              _c("span", { attrs: { title: data.item.text } }, [
                                _vm._v(" " + _vm._s(data.item.text) + "...")
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
              ]
            }
          }
        ]),
        model: {
          value: _vm.vModel,
          callback: function($$v) {
            _vm.vModel = $$v
          },
          expression: "vModel"
        }
      })
    : _c("div", [_vm._t("loader")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a10171e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a10171e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/search-selector/template.html
// module id = null
// module chunks = 